import React, {Fragment, useEffect, useState} from 'react'
import {connect} from 'react-redux';
import {getDiscounts} from "./actions";
import _ from 'lodash' ;
import {Link, useParams} from "react-router-dom";

const Discounts = (props) => {

    const {discounts} = props ;
    const {eventId} = useParams();

    useEffect(() => {
        props.getDiscounts(eventId);
    }, []);

    return (
        <Fragment>
            <div className="organizer addCategoryContainer">
                <div className="maximumSizeHandler mobileFlexCol">
                    <div className="categoryTable mobileWFull">
                        <table>
                            <tr className="font-size_16 mediumWFont">
                                <th>نام</th>
                                <th>درصد</th>
                                <th></th>
                            </tr>
                            {_.map(discounts , operator => {
                                return (
                                    <tr className="font-size_14">
                                        <td>{operator.name}</td>
                                        <td>{operator.amount}</td>
                                        <td><span className="icon icon-eraser" /><span className="icon icon-edit leftMargin" /></td>
                                        {/*<td className="blueColor">مشاهده نتایج <span className="icon icon-left font-size_12"></span></td>*/}
                                    </tr>
                                )
                            })}
                        </table>
                    </div>
                    <div className="addCategoryForm mobileWFull">

                        <div className="formContainer">
                            <div className="inputContainer">
                                <label>عنوان </label>
                                <input className="standardInput" />
                            </div>
                        </div>
                        <div className="inputContainer price withUnit">
                            <span className="unit">درصد</span>
                            <label>مقدار</label>
                            <input className="standardInput" />
                        </div>
                        <div className="inputContainer description">
                            <label>توضیحات</label>
                            <textarea className="standardInput"></textarea>
                        </div>

                        <div className="normalButton outlineMode greenButton"><span
                            className="icon icon-add font-size_14 middleContext"></span> اضافه به لیست
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = ({discounts}) => ({
    discounts
});

export default connect(mapStateToProps, {getDiscounts})(Discounts);
